import { hasValue } from "./helpers";

export const sortVolgnummer = <T extends { volgnummer?: number | null }>(o1: T, o2: T): number => {
  if (!hasValue(o1.volgnummer) && !hasValue(o2.volgnummer)) return 0;
  if (!hasValue(o1.volgnummer)) return -1;
  if (!hasValue(o2.volgnummer)) return 1;

  return o1.volgnummer - o2.volgnummer;
};
